import { useQuery } from '@tanstack/react-query';
import { dataCatalogApi } from '../lib/api.js';
import { queryKeys } from '../lib/query-keys.js';

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business データカタログ概要（全データセット・テーブルのメタデータ）を取得するフック。BQ構成変更時も自動追随する。
 * @graph-connects dataCatalogApi [calls] データカタログ API client
 * @graph-connects queryKeys [calls] Query key factory
 */
export function useDataCatalogOverview() {
  return useQuery({
    queryKey: queryKeys.dataCatalog.overview,
    queryFn: () => dataCatalogApi.getOverview(),
    staleTime: 5 * 60_000,
    retry: false,
  });
}

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business 指定テーブルのカラム詳細を取得するフック。
 * @graph-connects dataCatalogApi [calls] データカタログ API client
 * @graph-connects queryKeys [calls] Query key factory
 */
export function useTableColumns(datasetId: string | null, tableId: string | null) {
  const dsKey = datasetId ?? '';
  const tblKey = tableId ?? '';
  return useQuery({
    queryKey: queryKeys.dataCatalog.columns(dsKey, tblKey),
    queryFn: () => dataCatalogApi.getColumns(dsKey, tblKey),
    enabled: datasetId !== null && tableId !== null,
    staleTime: 10 * 60_000,
    retry: false,
  });
}
